import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoadingService } from '../services/loading.service';
import { LocalStorageService } from '../storage/local-storage.service';

export const customHttpInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const loadingService = inject(LoadingService);
    const localStorageService = inject(LocalStorageService);

    const skipGlobalLoading =
        req.url.includes('/notification/my-notifications') ||
        req.url.includes('/notifications/negotiate') ||
        req.url.includes('paginated') ||
        /** Sequential `survey_Start` in survey-form; template blocks have their own load state. */
        req.url.includes('/surveys');
    const requestId = generateRequestId(req);
    if (!skipGlobalLoading) {
        loadingService.showLoading(requestId);
    }

    if (req.url.startsWith(environment.apiBaseUrl)) {
        const token = localStorageService.getItem<string>('token');
        req = req.clone({
            setHeaders: {
                'x-app': environment.appId,
                'x-auth-token': token ? `Bearer ${token}` : '',
                'x-enterprise': '00000000-0000-0000-0000-000000000000',
            },
        });
    }

    if (req.url.includes('/surveys')) {
        req = req.clone({
            setHeaders: { 'X-Locale': '26c7ace9-13fc-43b8-9988-2384fe670d03' },
        });
    }

    // Azure Blob Storage için custom header ekleme - çalışmaz çünkü CORS ve Azure kendi auth mekanizmasını kullanır
    // Azure için SAS token URL parametresi olarak eklenmeli veya backend proxy kullanılmalı

    return next(req).pipe(
        finalize(() => {
            if (!skipGlobalLoading) {
                loadingService.hideLoading(requestId);
            }
        }),
        catchError((error: unknown) => {
            if (!skipGlobalLoading) {
                loadingService.hideLoading(requestId);
            }

            return throwError(() => error);
        })
    );
};

function generateRequestId(req: HttpRequest<unknown>): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 15);
    const method = req.method;
    const url = req.url;

    return `${method}_${url}_${timestamp}_${random}`;
}
